import { render, staticRenderFns } from "./MyHistory.vue?vue&type=template&id=a153bb54&"
import script from "./MyHistory.vue?vue&type=script&lang=js&"
export * from "./MyHistory.vue?vue&type=script&lang=js&"
import style0 from "./MyHistory.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports